import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { ProductTopBanner } from "../components/ProductTopBanner";
import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";
import { SearchUsers } from "components/SearchSelect/SearchUsers";
import { useState } from "react";
import { Button } from "@mui/material";
import { useGlobalContext } from "context/GlobalContext";
import { assignPMCToProductApi } from "API/apis/product/assignPMCToProduct";
import { useProductContext } from "../context";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useNavigate } from "react-router-dom";
import { routeLinks } from "constants/paths";
import { SEARCH_USER_DEPT_FILTER_LIST } from "constants/searchUserContants";
import { message } from "constants/responses/message";

const initialUserDetail = {
  name: "",
  dept: "",
  subDept: "",
  userId: "",
};

export const ProductAssignToPmc = () => {
  const [selectedUser, setSelectedUser] = useState(initialUserDetail);
  const { setIsLoading, setSuccess, setError } = useGlobalContext();
  const { currentProject, selectedRowId } = useProductContext();
  const navigate = useNavigate();

  const handleAssignPMCSubmit = async (e) => {
    e.preventDefault();
    const assignableRows = { ok: [], reject: [] };
    selectedRowId.forEach((item) => {
      if (
        item?.executionTimeline?.endDate &&
        item.lotPartDeadline > item.executionTimeline.endDate &&
        !item.isPmcApproved
      ) {
        assignableRows.ok.push(Number(item.lotPartId));
      } else if (
        !item?.executionTimeline?.endDate ||
        item.lotPartDeadline < item.executionTimeline.endDate
      ) {
        assignableRows.reject.push(
          `${item.partLotDocCode} : execution timeline is higher than the deadline`
        );
      } else if (item.isPmcApproved) {
        assignableRows.reject.push(`${item.partLotDocCode} : already approved`);
      }
    });
    try {
      if (assignableRows.ok.length > 0) {
        setIsLoading(true);
        const { data, status } = await assignPMCToProductApi({
          pm: selectedUser.userId,
          productLotId: assignableRows.ok,
        });
        if (status !== STATUS_CODES.SUCCESS) {
          throw new Error(data.message);
        }
      }
      setSuccess(
        assignableRows?.reject?.join("\n") ||
          message.success.generalSuccessUpdateMessage
      );
      setIsLoading(false);
      navigate(routeLinks.projectManagementProject + "/" + currentProject);
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    }
  };

  return (
    <>
      <PageTitle pageName={pageName.product.assignPmc} />
      <ProductTopBanner buttonType="back" />
      <form onSubmit={handleAssignPMCSubmit}>
        <FormControlWrapper fullWidth>
          <SearchUsers
            label="Assign To"
            handleUserSelection={setSelectedUser}
            selectedUser={selectedUser}
            isRequired={true}
            deptFilter={SEARCH_USER_DEPT_FILTER_LIST.ASSIGN_PMC}
          />
        </FormControlWrapper>{" "}
        <Button variant="contained" type="submit" fullWidth>
          Submit
        </Button>
      </form>
    </>
  );
};
